import { API, Auth } from 'aws-amplify';

export const callCalculateVitalsAbnormalities = async (input: any): Promise<string> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/calculate-vitals-abnormalities', {
            body: input,
            headers: {
                'Content-Type': 'application/json',
            }
        });

        console.log('callCalculateVitalsAbnormalities response', JSON.parse(response.response));
        return response.response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callCalculateVitalsAbnormalities");
        return "";
    }
}
